var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 9.55002V13.7167C1.66602 15.625 3.20768 17.1667 5.11602 17.1667H14.8743C16.7827 17.1667 18.3327 15.6167 18.3327 13.7084V9.55002C18.3327 8.99169 17.8827 8.54169 17.3243 8.54169H2.67435C2.11602 8.54169 1.66602 8.99169 1.66602 9.55002ZM6.66602 14.375H4.99935C4.65768 14.375 4.37435 14.0917 4.37435 13.75C4.37435 13.4084 4.65768 13.125 4.99935 13.125H6.66602C7.00768 13.125 7.29102 13.4084 7.29102 13.75C7.29102 14.0917 7.00768 14.375 6.66602 14.375ZM12.0827 14.375H8.74935C8.40768 14.375 8.12435 14.0917 8.12435 13.75C8.12435 13.4084 8.40768 13.125 8.74935 13.125H12.0827C12.4243 13.125 12.7077 13.4084 12.7077 13.75C12.7077 14.0917 12.4243 14.375 12.0827 14.375Z",
    fill: "url(#paint0_linear_38_11185)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 9.55002V13.7167C1.66602 15.625 3.20768 17.1667 5.11602 17.1667H14.8743C16.7827 17.1667 18.3327 15.6167 18.3327 13.7084V9.55002C18.3327 8.99169 17.8827 8.54169 17.3243 8.54169H2.67435C2.11602 8.54169 1.66602 8.99169 1.66602 9.55002ZM6.66602 14.375H4.99935C4.65768 14.375 4.37435 14.0917 4.37435 13.75C4.37435 13.4084 4.65768 13.125 4.99935 13.125H6.66602C7.00768 13.125 7.29102 13.4084 7.29102 13.75C7.29102 14.0917 7.00768 14.375 6.66602 14.375ZM12.0827 14.375H8.74935C8.40768 14.375 8.12435 14.0917 8.12435 13.75C8.12435 13.4084 8.40768 13.125 8.74935 13.125H12.0827C12.4243 13.125 12.7077 13.4084 12.7077 13.75C12.7077 14.0917 12.4243 14.375 12.0827 14.375Z",
    fill: "url(#paint1_linear_38_11185)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2493 3.84165V6.28331C11.2493 6.84165 10.7993 7.29165 10.241 7.29165H2.67435C2.10768 7.29165 1.66602 6.82498 1.66602 6.26665C1.67435 5.32498 2.04935 4.46665 2.67435 3.84165C3.29935 3.21665 4.16602 2.83331 5.11602 2.83331H10.241C10.7993 2.83331 11.2493 3.28331 11.2493 3.84165Z",
    fill: "#BDCEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6417 1.66669H14.1917C13.1333 1.66669 12.5 2.30002 12.5 3.35835V5.80835C12.5 6.86669 13.1333 7.50002 14.1917 7.50002H16.6417C17.7 7.50002 18.3333 6.86669 18.3333 5.80835V3.35835C18.3333 2.30002 17.7 1.66669 16.6417 1.66669ZM17.1917 3.70835L15.2167 6.01669C15.1417 6.10835 15.025 6.16669 14.9083 6.16669C14.9 6.16669 14.9 6.16669 14.8917 6.16669C14.775 6.16669 14.6667 6.12502 14.5833 6.04169L13.6667 5.14169C13.5 4.97502 13.5 4.70002 13.6667 4.53335C13.8333 4.36669 14.1083 4.35835 14.275 4.53335L14.8583 5.10835L16.525 3.15835C16.6833 2.97502 16.95 2.95835 17.1333 3.10835C17.325 3.25835 17.3417 3.53335 17.1917 3.70835Z",
    fill: "url(#paint2_linear_38_11185)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6417 1.66669H14.1917C13.1333 1.66669 12.5 2.30002 12.5 3.35835V5.80835C12.5 6.86669 13.1333 7.50002 14.1917 7.50002H16.6417C17.7 7.50002 18.3333 6.86669 18.3333 5.80835V3.35835C18.3333 2.30002 17.7 1.66669 16.6417 1.66669ZM17.1917 3.70835L15.2167 6.01669C15.1417 6.10835 15.025 6.16669 14.9083 6.16669C14.9 6.16669 14.9 6.16669 14.8917 6.16669C14.775 6.16669 14.6667 6.12502 14.5833 6.04169L13.6667 5.14169C13.5 4.97502 13.5 4.70002 13.6667 4.53335C13.8333 4.36669 14.1083 4.35835 14.275 4.53335L14.8583 5.10835L16.525 3.15835C16.6833 2.97502 16.95 2.95835 17.1333 3.10835C17.325 3.25835 17.3417 3.53335 17.1917 3.70835Z",
    fill: "url(#paint3_linear_38_11185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_11185",
    x1: 9.99935,
    y1: 8.54169,
    x2: 9.99935,
    y2: 17.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_11185",
    x1: 9.99935,
    y1: 7.50002,
    x2: 9.99935,
    y2: 17.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_11185",
    x1: 15.4167,
    y1: 1.66669,
    x2: 15.4167,
    y2: 7.50002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_11185",
    x1: 15.4167,
    y1: 0.962178,
    x2: 15.4167,
    y2: 7.50002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/activated.3cd634058b97e47a6d4822ebc0f98914.svg";
export { ForwardRef as ReactComponent };